export default function ContactSection() {
  return (
    <section id="contact" className="py-16 sm:py-24 lg:py-32 bg-gradient-to-b from-[#FAF0E6] to-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-8">
        <div className="text-center mb-12 sm:mb-16 space-y-4">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2C2C]">
            お問い合わせ
          </h2>
          <p className="text-base sm:text-lg text-[#757575] max-w-3xl mx-auto leading-relaxed">
            ご不明な点やご相談がございましたら、お気軽にお問い合わせください
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
            <div className="bg-gradient-to-br from-[#66BB6A] to-[#4CAF50] p-8 sm:p-12 lg:p-16 text-white space-y-8">
              <div className="space-y-4">
                <h3 className="text-3xl sm:text-4xl font-bold">
                  ぽかぽか堂<br />
                  よりみち相談室 WEB支援
                </h3>
                <p className="text-lg leading-relaxed opacity-95">
                  埼玉県北葛飾郡松伏町松伏1-9-9-6
                </p>
              </div>

              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full flex-shrink-0">
                    <i className="ri-phone-line text-2xl"></i>
                  </div>
                  <div>
                    <div className="text-sm opacity-90 mb-1">お電話でのお問い合わせ</div>
                    <a href="tel:08034796908" className="text-2xl font-bold hover:underline cursor-pointer whitespace-nowrap">
                      TEL 080-3479-6908
                    </a>
                    <div className="text-sm opacity-90 mt-1">担当：今野直子</div>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full flex-shrink-0">
                    <i className="ri-mail-line text-2xl"></i>
                  </div>
                  <div>
                    <div className="text-sm opacity-90 mb-1">メールでのお問い合わせ</div>
                    <a href="mailto:nao6091970@gmail.com" className="text-xl font-bold hover:underline cursor-pointer break-all">
                      nao6091970@gmail.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full flex-shrink-0">
                    <i className="ri-line-line text-2xl"></i>
                  </div>
                  <div className="flex-1">
                    <div className="text-sm opacity-90 mb-2">公式LINEでのお問い合わせ</div>
                    <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-4 inline-block">
                      <img 
                        alt="公式LINE QRコード" 
                        className="w-32 h-32" 
                        src="https://static.readdy.ai/image/a94bf782443eac1605091ed034a69659/d790a885eec04ae03911127a5d7921b5.png"
                      />
                    </div>
                    <p className="text-sm opacity-90 mt-2">
                      相談員と直接やり取りができます
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="p-8 sm:p-12 lg:p-16 space-y-6">
              <div className="space-y-4">
                <h4 className="text-2xl font-bold text-[#2C2C2C]">
                  お気軽にご相談ください
                </h4>
                <p className="text-base text-[#757575] leading-relaxed">
                  チラシ制作、ネットショップ立ち上げ、アプリ制作など、デジタル化に関するご相談を承っております。まずはお気軽にお問い合わせください。
                </p>
              </div>

              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-[#66BB6A]"></i>
                  </div>
                  <p className="text-base text-[#2C2C2C] leading-relaxed">
                    <strong className="font-bold">初回相談無料</strong>でお見積りいたします
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-[#66BB6A]"></i>
                  </div>
                  <p className="text-base text-[#2C2C2C] leading-relaxed">
                    <strong className="font-bold">柔軟な対応</strong>でお客様のニーズに合わせます
                  </p>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-xl text-[#66BB6A]"></i>
                  </div>
                  <p className="text-base text-[#2C2C2C] leading-relaxed">
                    <strong className="font-bold">アフターサポート</strong>も充実しています
                  </p>
                </div>
              </div>

              <div className="bg-gradient-to-r from-[#E8F5E9] to-[#C8E6C9] rounded-2xl p-6">
                <p className="text-base text-[#2C2C2C] leading-relaxed">
                  <i className="ri-time-line text-xl text-[#66BB6A] mr-2"></i>
                  営業時間：平日 9:00〜18:00<br />
                  <span className="text-sm text-[#757575] ml-7">※土日祝日はメール・LINEでの受付のみ</span>
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* お問い合わせフォームバナー */}
        <div className="mt-12 sm:mt-16">
          <a 
            href="/#contact" 
            className="block bg-gradient-to-r from-[#66BB6A] to-[#4CAF50] rounded-2xl p-8 sm:p-10 shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] cursor-pointer group"
          >
            <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
              <div className="flex items-center gap-6">
                <div className="w-16 h-16 flex items-center justify-center bg-white/20 backdrop-blur-sm rounded-full flex-shrink-0 group-hover:bg-white/30 transition-all duration-300">
                  <i className="ri-mail-send-line text-3xl text-white"></i>
                </div>
                <div className="text-center sm:text-left">
                  <h3 className="text-2xl sm:text-3xl font-bold text-white mb-2">
                    お問い合わせフォームはこちら
                  </h3>
                  <p className="text-base text-white/90">
                    24時間受付中！フォームからお気軽にご相談ください
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-2 text-white group-hover:translate-x-2 transition-transform duration-300">
                <span className="text-lg font-bold whitespace-nowrap">フォームへ</span>
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
